import { Location } from 'history';
import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from 'src/store';
import { logout } from 'src/store/auth/actions';
import { LayoutState, LayoutActionTypes } from 'src/store/layout/types';
import { User } from 'src/store/user/types';
import { colorLight, colorPrimary } from 'src/variables';
import './Navbar.scss';
import { Link } from 'react-router-dom';
import { url } from 'src';
import { IconPaths } from 'src/icons';
import { action } from 'typesafe-actions';

// import { hasToken } from 'src/utils/authHelper';

interface Props {
  user?: User;
  layout: LayoutState;
  path: Location;

  logout: any;
  showNavbar: any;
  hideNavbar: any;
}

type AllProps = Props;
// {selectedSection != null && path !== `/section/${selectedSection}` && path !== '/' ? (
//   <Link to={`/section/${selectedSection}`}>Zurück zur Programmübersicht</Link>
// ) : path !== '/' ? (
//   <Link to={`/`}>Zurück zur Themenbereichübersicht</Link>
// ) : null}

class Navbar extends React.Component<AllProps> {
  showMenu = () => {
    this.props.showNavbar();
  };

  hideMenu = () => {
    this.props.hideNavbar();
  };

  logout = () => {
    this.props.logout();
    this.props.hideNavbar();
  };

  render() {
    const { user, path } = this.props;
    const open = this.props.layout.navbarDropdown;
    return (
      <div className="navbar full pd-f">
        <div className="container">
          <div
            style={{
              height: '100%',
              alignItems: 'center',
              position: 'relative'
            }}
            className="clearfix"
          >
            <div
              className="lefter"
              style={{
                float: 'left',
                paddingLeft: '40px',
                height: '100%',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              {path.pathname !== '/' && (path.pathname !== '/login' && path.pathname !== '/impressum') && <Link to={`/`}>Home</Link>}
            </div>
            <div
              className={`left ${
                path.pathname !== '/' && (path.pathname !== '/login' && path.pathname !== '/impressum') ? 'offset' : ''
                }`}
              style={{
                display: 'flex',
                float: 'left',
                flexDirection: 'row',
                position: 'relative'
              }}
            >
              {user && (
                <div
                  onMouseEnter={this.showMenu}
                  onMouseLeave={this.hideMenu}
                  style={{ position: 'relative' }}
                >
                  <img
                    onClick={this.showMenu}
                    className="imgHeight"
                    style={{ height: '25px', marginRight: '20px', cursor: 'pointer' }}
                    src={IconPaths['user-icon']}
                  />
                  <ul
                    style={{
                      display: open ? 'block' : 'none',
                      position: 'absolute',
                      left: '0',
                      bottom: '-41px',
                      backgroundColor: colorPrimary,
                      color: colorLight,
                      margin: 0,
                      padding: '0 10px',
                      width: 'auto',
                      border: `2px solid ${colorLight}`,
                      borderTop: 'none'
                    }}
                  >
                    <li className="pointer" onClick={this.logout}>
                      Logout
                    </li>
                  </ul>
                </div>
              )}
              <span style={{ textTransform: 'uppercase' }}>
                <span className="hideOnMobile">Herzlich Willkommen</span> {user && user.name}
                {user && user.image && user.image.url && (
                  <img
                    src={url + user.image.url}
                    style={{ marginLeft: '20px' }}
                    height="30px"
                    width="auto"
                  />
                )}
              </span>
            </div>
            <div className="right hideOnMobile">
              {user && (
                <div className="menu">
                  <Link to="/manage">Einstellungen</Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth, layout, router }: ApplicationState) => ({
  user: auth.data,
  layout,
  path: router.location
});

const mapDispatchToProps = (dispatch: any) => ({
  showNavbar: () => dispatch(action(LayoutActionTypes.SHOW_NAVBAR)),
  hideNavbar: () => dispatch(action(LayoutActionTypes.HIDE_NAVBAR)),
  logout: () => dispatch(logout())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Navbar);



// WEBPACK FOOTER //
// ./src/components/layout/Header/Navbar/Navbar.tsx